'use client';
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// biome-ignore-all lint: auto-generated code
// deno-lint-ignore-file

import useSWR, {type SWRConfiguration, type Key as SWRKey} from 'swr';
import useSWRMutation, {type SWRMutationConfiguration} from 'swr/mutation';

interface SwrConfig extends SWRConfiguration {
  /* Custom key for SWR. You don't have to worry about this as by default it's the URL. You can use standard SWR Key here if you need more flexibility. */
  key?: SWRKey;
}
import type {Options as KyOptions} from 'ky';
import * as API from './api';

export const organizations = {
  queries: {
    /**
     * Get a single organization entity by its ID
     * @param organizationId - Organization Identifier
     */
    useOrganization(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? organizations.queryKeys.organization(organizationId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.GetOrganizationResponse>(
        cacheUrl,
        () => API.organizationsClient.getOrganization(organizationId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Delete a single organization entity by its ID
     * @param organizationId - Organization Identifier
     */
    useDeleteOrganization(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string}>(
        '/organizations/*',
        (_key: string, {arg}: {arg: {organizationId: string}}) =>
          API.organizationsClient.deleteOrganization(arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Request organization license upgrade to Enterprise
     * @param body
     * @param organizationId - Organization Identifier
     */
    useRequestOrganizationLicenseUpgrade(
      $config?: SWRMutationConfiguration<
        API.OrganizationLicenseUpgradeResponse,
        Error,
        string,
        {body: API.OrganizationLicenseUpgradeRequest; organizationId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.OrganizationLicenseUpgradeResponse,
        Error,
        string,
        {body: API.OrganizationLicenseUpgradeRequest; organizationId: string}
      >(
        '/organizations/*/license/upgrade-request',
        (_key: string, {arg}: {arg: {body: API.OrganizationLicenseUpgradeRequest; organizationId: string}}) =>
          API.organizationsClient.requestOrganizationLicenseUpgrade(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Update a single organization entity by its ID
     * @param body
     * @param organizationId - Organization Identifier
     */
    useUpdateOrganization(
      $config?: SWRMutationConfiguration<
        API.UpdateOrganizationResponse,
        Error,
        string,
        {body: API.UpdateOrganizationRequest; organizationId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.UpdateOrganizationResponse,
        Error,
        string,
        {body: API.UpdateOrganizationRequest; organizationId: string}
      >(
        '/organizations/*',
        (_key: string, {arg}: {arg: {body: API.UpdateOrganizationRequest; organizationId: string}}) =>
          API.organizationsClient.updateOrganization(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    organization: (organizationId: string) => `/organizations/${encodeURIComponent(`${organizationId}`)}`,
  },
};

export const auditLogs = {
  queries: {
    /**
     * Fetch a single forwarding config for an organization
     * @param organizationId - Organization Identifier
     * @param forwardingConfigId
     */
    useAuditLogForwardingConfig(
      organizationId: string,
      forwardingConfigId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? auditLogs.queryKeys.auditLogForwardingConfig(organizationId, forwardingConfigId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.AuditLogForwardingConfig>(
        cacheUrl,
        () => API.auditLogsClient.getAuditLogForwardingConfig(organizationId, forwardingConfigId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Query audit log forwarding configs for an organization
     * @param organizationId - Organization Identifier
     */
    useAuditLogForwardingConfigsByOrganization(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? auditLogs.queryKeys.auditLogForwardingConfigsByOrganization(organizationId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.AuditLogForwardingConfig[]>(
        cacheUrl,
        () => API.auditLogsClient.getAuditLogForwardingConfigsByOrganization(organizationId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Query audit logs for an organization
     * @param organizationId - Organization Identifier
     * @param queryParams (optional) - Grouped query parameters object (from, to, limit)
     */
    useAuditLogsByOrganization(
      organizationId: string,
      queryParams?: {from?: string | null; to?: string | null; limit?: number | null} | null,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? auditLogs.queryKeys.auditLogsByOrganization(organizationId, queryParams);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.AuditLog[]>(
        cacheUrl,
        () => API.auditLogsClient.getAuditLogsByOrganization(organizationId, queryParams, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Create an audit log forwarding config for an organization
     * @param body
     * @param organizationId - Organization Identifier
     */
    useCreateAuditLogForwardingConfig(
      $config?: SWRMutationConfiguration<
        API.AuditLogForwardingConfig,
        Error,
        string,
        {body: API.CreateAuditLogForwardingConfigRequest; organizationId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.AuditLogForwardingConfig,
        Error,
        string,
        {body: API.CreateAuditLogForwardingConfigRequest; organizationId: string}
      >(
        '/organizations/*/audit-log-forwarding-configs',
        (_key: string, {arg}: {arg: {body: API.CreateAuditLogForwardingConfigRequest; organizationId: string}}) =>
          API.auditLogsClient.createAuditLogForwardingConfig(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Delete a forwarding config for an organization
     * @param organizationId - Organization Identifier
     * @param forwardingConfigId
     */
    useDeleteAuditLogForwardingConfig(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; forwardingConfigId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; forwardingConfigId: string}>(
        '/organizations/*/audit-log-forwarding-configs/*',
        (_key: string, {arg}: {arg: {organizationId: string; forwardingConfigId: string}}) =>
          API.auditLogsClient.deleteAuditLogForwardingConfig(arg.organizationId, arg.forwardingConfigId, $httpConfig),
        $config,
      );
    },

    /**
     * Send a sample audit log event based on a provided forwarding configuration
     * @param body
     * @param organizationId - Organization Identifier
     */
    useTestAuditLogForwardingConfig(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: API.CreateAuditLogForwardingConfigRequest; organizationId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: API.CreateAuditLogForwardingConfigRequest; organizationId: string}
      >(
        '/organizations/*/audit-log-forwarding-configs/test',
        (_key: string, {arg}: {arg: {body: API.CreateAuditLogForwardingConfigRequest; organizationId: string}}) =>
          API.auditLogsClient.testAuditLogForwardingConfig(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Update a forwarding config for an organization
     * @param body
     * @param organizationId - Organization Identifier
     * @param forwardingConfigId
     */
    useUpdateAuditLogForwardingConfig(
      $config?: SWRMutationConfiguration<
        API.AuditLogForwardingConfig,
        Error,
        string,
        {body: API.UpdateAuditLogForwardingConfigRequest; organizationId: string; forwardingConfigId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.AuditLogForwardingConfig,
        Error,
        string,
        {body: API.UpdateAuditLogForwardingConfigRequest; organizationId: string; forwardingConfigId: string}
      >(
        '/organizations/*/audit-log-forwarding-configs/*',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {body: API.UpdateAuditLogForwardingConfigRequest; organizationId: string; forwardingConfigId: string};
          },
        ) =>
          API.auditLogsClient.updateAuditLogForwardingConfig(
            arg.body,
            arg.organizationId,
            arg.forwardingConfigId,
            $httpConfig,
          ),
        $config,
      );
    },
  },

  queryKeys: {
    auditLogForwardingConfig: (organizationId: string, forwardingConfigId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs/${encodeURIComponent(`${forwardingConfigId}`)}`,
    auditLogForwardingConfigsByOrganization: (organizationId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs`,
    auditLogsByOrganization: (
      organizationId: string,
      queryParams?: {from?: string | null; to?: string | null; limit?: number | null} | null,
    ) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/audit-logs?${API.encodeParams({from: queryParams?.from, to: queryParams?.to, limit: queryParams?.limit})}`,
  },
};

export const clients = {
  queries: {
    /**
     * Get an API Client by clientId
     * @param organizationId - Organization Identifier
     * @param clientId - API Credential Client Internal Identifier
     */
    useApiClient(
      organizationId: string,
      clientId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? clients.queryKeys.apiClient(organizationId, clientId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Client>(
        cacheUrl,
        () => API.clientsClient.getApiClient(organizationId, clientId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get Api Client Secret
     * @param organizationId - Organization Identifier
     * @param clientId - API Credential Client Internal Identifier
     */
    useApiClientSecret(
      organizationId: string,
      clientId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? clients.queryKeys.apiClientSecret(organizationId, clientId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<{secret?: string}>(
        cacheUrl,
        () => API.clientsClient.getApiClientSecret(organizationId, clientId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get all API Credential Clients for an organization
     * @param organizationId - Organization Identifier
     */
    useApiClientsByOrganization(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? clients.queryKeys.apiClientsByOrganization(organizationId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Client[]>(
        cacheUrl,
        () => API.clientsClient.getApiClientsByOrganization(organizationId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get all API Credential Clients for a workspace
     * @param organizationId - Organization Identifier
     * @param workspaceId - Workspace name (ie. main)
     */
    useApiClientsByWorkspace(
      organizationId: string,
      workspaceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? clients.queryKeys.apiClientsByWorkspace(organizationId, workspaceId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.WorkspaceClient[]>(
        cacheUrl,
        () => API.clientsClient.getApiClientsByWorkspace(organizationId, workspaceId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Create a new API Client
     * @param body
     * @param organizationId - Organization Identifier
     */
    useCreateApiClient(
      $config?: SWRMutationConfiguration<API.Client, Error, string, {body: API.ClientCreate; organizationId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<API.Client, Error, string, {body: API.ClientCreate; organizationId: string}>(
        '/organizations/*/clients',
        (_key: string, {arg}: {arg: {body: API.ClientCreate; organizationId: string}}) =>
          API.clientsClient.createApiClient(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Deletes a single API Client in an organization
     * Deletes a single API Client from an organization
     * @param organizationId - Organization Identifier
     * @param clientId - API Credential Client Internal Identifier
     */
    useDeleteApiClient(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; clientId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; clientId: string}>(
        '/organizations/*/clients/*',
        (_key: string, {arg}: {arg: {organizationId: string; clientId: string}}) =>
          API.clientsClient.deleteApiClient(arg.organizationId, arg.clientId, $httpConfig),
        $config,
      );
    },

    /**
     * Deletes all API Clients in an organization
     * Deletes all API Clients from an organization
     * @param organizationId - Organization Identifier
     */
    useDeleteApiClients(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string}>(
        '/organizations/*/clients',
        (_key: string, {arg}: {arg: {organizationId: string}}) =>
          API.clientsClient.deleteApiClients(arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Update an API Client
     * @param body
     * @param organizationId - Organization Identifier
     * @param clientId - API Credential Client Internal Identifier
     */
    useUpdateApiClient(
      $config?: SWRMutationConfiguration<
        API.Client,
        Error,
        string,
        {body: API.ClientUpdate; organizationId: string; clientId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.Client,
        Error,
        string,
        {body: API.ClientUpdate; organizationId: string; clientId: string}
      >(
        '/organizations/*/clients/*',
        (_key: string, {arg}: {arg: {body: API.ClientUpdate; organizationId: string; clientId: string}}) =>
          API.clientsClient.updateApiClient(arg.body, arg.organizationId, arg.clientId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    apiClient: (organizationId: string, clientId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/clients/${encodeURIComponent(`${clientId}`)}`,
    apiClientSecret: (organizationId: string, clientId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/clients/${encodeURIComponent(`${clientId}`)}/secret`,
    apiClientsByOrganization: (organizationId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/clients`,
    apiClientsByWorkspace: (organizationId: string, workspaceId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/clients`,
  },
};

export const connections = {
  queries: {
    /**
     * Returns the current SSO connection
     * Gets either an OIDC or SAML SSO connection for an organization (only 1 is permitted)
     * @param organizationId - Organization Identifier
     */
    useSSOConnection(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? connections.queryKeys.sSOConnection(organizationId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Connection>(
        cacheUrl,
        () => API.connectionsClient.getSSOConnection(organizationId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Deletes the current SSO connection
     * Delete the current SSO connection. Be sure to warn the user first; this is a dangerous operation.
     * @param organizationId - Organization Identifier
     */
    useDeleteSSOConnection(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string}>(
        '/organizations/*/connections/sso',
        (_key: string, {arg}: {arg: {organizationId: string}}) =>
          API.connectionsClient.deleteSSOConnection(arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Update the SSO connection
     * Update either an OIDC or SAML SSO connection for an organization
     * @param body
     * @param organizationId - Organization Identifier
     */
    usePatchSSOConnection(
      $config?: SWRMutationConfiguration<
        API.Connection,
        Error,
        string,
        {body: API.UpdateConnection; organizationId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<API.Connection, Error, string, {body: API.UpdateConnection; organizationId: string}>(
        '/organizations/*/connections/sso',
        (_key: string, {arg}: {arg: {body: API.UpdateConnection; organizationId: string}}) =>
          API.connectionsClient.patchSSOConnection(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Create the SSO connection
     * Creates either an OIDC or SAML SSO connection for an organization (only 1 is permitted)
     * @param body
     * @param organizationId - Organization Identifier
     */
    usePostSSOConnection(
      $config?: SWRMutationConfiguration<
        API.Connection,
        Error,
        string,
        {body: API.CreateOIDCConnectionRequest | API.CreateSAMLConnectionRequest; organizationId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.Connection,
        Error,
        string,
        {body: API.CreateOIDCConnectionRequest | API.CreateSAMLConnectionRequest; organizationId: string}
      >(
        '/organizations/*/connections/sso',
        (
          _key: string,
          {
            arg,
          }: {arg: {body: API.CreateOIDCConnectionRequest | API.CreateSAMLConnectionRequest; organizationId: string}},
        ) => API.connectionsClient.postSSOConnection(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    sSOConnection: (organizationId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/connections/sso`,
  },
};

export const invites = {
  queries: {
    /**
     * Get a list of invites for an organization
     * @param organizationId - Organization Identifier
     */
    useInvites(organizationId: string, $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey}, $httpConfig?: KyOptions) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? invites.queryKeys.invites(organizationId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.InviteArray>(
        cacheUrl,
        () => API.invitesClient.getInvites(organizationId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Delete an invite
     * @param organizationId - Organization Identifier
     * @param inviteId - Invite Identifier
     */
    useDeleteInvite(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; inviteId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; inviteId: string}>(
        '/organizations/*/invites/*',
        (_key: string, {arg}: {arg: {organizationId: string; inviteId: string}}) =>
          API.invitesClient.deleteInvite(arg.organizationId, arg.inviteId, $httpConfig),
        $config,
      );
    },

    /**
     * Invite a user to join an organization
     * @param body
     * @param organizationId - Organization Identifier
     */
    useInviteUserToOrganization(
      $config?: SWRMutationConfiguration<
        {id?: string},
        Error,
        string,
        {
          body: {recipient: string; recipientFirstName?: string; recipientLastName?: string; roles: API.Role[]};
          organizationId: string;
        }
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        {id?: string},
        Error,
        string,
        {
          body: {recipient: string; recipientFirstName?: string; recipientLastName?: string; roles: API.Role[]};
          organizationId: string;
        }
      >(
        '/organizations/*/invites',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {
              body: {recipient: string; recipientFirstName?: string; recipientLastName?: string; roles: API.Role[]};
              organizationId: string;
            };
          },
        ) => API.invitesClient.inviteUserToOrganization(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * Accept an invite to join an organization
     * @param organizationId - Organization Identifier
     * @param inviteId - Invite Identifier
     */
    usePostAcceptInvite(
      $config?: SWRMutationConfiguration<
        {location?: string},
        Error,
        string,
        {organizationId: string; inviteId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<{location?: string}, Error, string, {organizationId: string; inviteId: string}>(
        '/organizations/*/invites/*',
        (_key: string, {arg}: {arg: {organizationId: string; inviteId: string}}) =>
          API.invitesClient.postAcceptInvite(arg.organizationId, arg.inviteId, $httpConfig),
        $config,
      );
    },

    /**
     * Resend an invite
     * @param organizationId - Organization Identifier
     * @param inviteId - Invite Identifier
     */
    useResendInvite(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; inviteId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; inviteId: string}>(
        '/organizations/*/invites/*/resend',
        (_key: string, {arg}: {arg: {organizationId: string; inviteId: string}}) =>
          API.invitesClient.resendInvite(arg.organizationId, arg.inviteId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    invites: (organizationId: string) => `/organizations/${encodeURIComponent(`${organizationId}`)}/invites`,
  },
};

export const members = {
  queries: {
    /**
     * Get all the teams for a member of an organization
     * @param organizationId - Organization Identifier
     * @param userId - User Identifier
     */
    useAllTeamsForMember(
      organizationId: string,
      userId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? members.queryKeys.allTeamsForMember(organizationId, userId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.GetTeamsForMemberResponse>(
        cacheUrl,
        () => API.membersClient.getAllTeamsForMember(organizationId, userId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get member roles by workspace
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param userId - User Identifier
     */
    useMemberRolesByWorkspace(
      organizationId: string,
      workspace: string,
      userId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? members.queryKeys.memberRolesByWorkspace(organizationId, workspace, userId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<{
        orgRole?: API.OrgRole;
        productRoles?: API.ProductRoles;
        workspaceRole?: API.WorkspaceRole;
      }>(
        cacheUrl,
        () => API.membersClient.getMemberRolesByWorkspace(organizationId, workspace, userId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get the roles of a member of an organization
     * @param organizationId - Organization Identifier
     * @param userId - User Identifier
     * @param consistency (optional) - Consistency mode for FGA reads. Use 'high' to ensure strongly-consistent results immediately after a write.
     */
    useOrganizationMemberRoles(
      organizationId: string,
      userId: string,
      consistency?: 'standard' | 'high' | null,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? members.queryKeys.organizationMemberRoles(organizationId, userId, consistency);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.MemberRoles>(
        cacheUrl,
        () => API.membersClient.getOrganizationMemberRoles(organizationId, userId, consistency, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get members of an organization
     * @param organizationId - Organization Identifier
     */
    useOrganizationMembers(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? members.queryKeys.organizationMembers(organizationId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Member[]>(
        cacheUrl,
        () => API.membersClient.getOrganizationMembers(organizationId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get members of an organization by product
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param product - Product name (ie. stream, lake, or pipeline)
     */
    useOrganizationMembersByProduct(
      organizationId: string,
      workspace: string,
      product: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? members.queryKeys.organizationMembersByProduct(organizationId, workspace, product);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Member[]>(
        cacheUrl,
        () => API.membersClient.getOrganizationMembersByProduct(organizationId, workspace, product, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Add an existing member to an organization
     * @param body
     * @param organizationId - Organization Identifier
     * @param userId - User Identifier
     */
    useAddMemberToOrganization(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: API.OrgRole; organizationId: string; userId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {body: API.OrgRole; organizationId: string; userId: string}>(
        '/organizations/*/members/*',
        (_key: string, {arg}: {arg: {body: API.OrgRole; organizationId: string; userId: string}}) =>
          API.membersClient.addMemberToOrganization(arg.body, arg.organizationId, arg.userId, $httpConfig),
        $config,
      );
    },

    /**
     * Remove a member from an organization
     * @param organizationId - Organization Identifier
     * @param userId - User Identifier
     */
    useRemoveMemberFromOrganization(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; userId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; userId: string}>(
        '/organizations/*/members/*',
        (_key: string, {arg}: {arg: {organizationId: string; userId: string}}) =>
          API.membersClient.removeMemberFromOrganization(arg.organizationId, arg.userId, $httpConfig),
        $config,
      );
    },

    /**
     * Remove a member from a workspace
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param userId - User Identifier
     */
    useRemoveMemberFromWorkspace(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {organizationId: string; workspace: string; userId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; workspace: string; userId: string}>(
        '/organizations/*/workspaces/*/members/*',
        (_key: string, {arg}: {arg: {organizationId: string; workspace: string; userId: string}}) =>
          API.membersClient.removeMemberFromWorkspace(arg.organizationId, arg.workspace, arg.userId, $httpConfig),
        $config,
      );
    },

    /**
     * Update organization role for a member
     * @param body
     * @param organizationId - Organization Identifier
     * @param userId - User Identifier
     */
    useUpdateOrganizationRoleForMember(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: API.OrgRole; organizationId: string; userId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {body: API.OrgRole; organizationId: string; userId: string}>(
        '/organizations/*/members/*/roles',
        (_key: string, {arg}: {arg: {body: API.OrgRole; organizationId: string; userId: string}}) =>
          API.membersClient.updateOrganizationRoleForMember(arg.body, arg.organizationId, arg.userId, $httpConfig),
        $config,
      );
    },

    /**
     * Update product roles for a member
     * @deprecated
     * @param body
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param userId - User Identifier
     */
    useUpdateProductRolesForMember(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: API.ProductRoles[]; organizationId: string; workspace: string; userId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: API.ProductRoles[]; organizationId: string; workspace: string; userId: string}
      >(
        '/organizations/*/workspaces/*/members/*/roles',
        (
          _key: string,
          {arg}: {arg: {body: API.ProductRoles[]; organizationId: string; workspace: string; userId: string}},
        ) =>
          API.membersClient.updateProductRolesForMember(
            arg.body,
            arg.organizationId,
            arg.workspace,
            arg.userId,
            $httpConfig,
          ),
        $config,
      );
    },

    /**
     * Update workspace and/or product roles for a member
     * @param body
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param userId - User Identifier
     */
    useUpdateWorkspaceRolesForMember(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {
          body: {productRoles?: API.ProductRoles; workspaceRole?: API.WorkspaceRole};
          organizationId: string;
          workspace: string;
          userId: string;
        }
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {
          body: {productRoles?: API.ProductRoles; workspaceRole?: API.WorkspaceRole};
          organizationId: string;
          workspace: string;
          userId: string;
        }
      >(
        '/organizations/*/workspaces/*/members/*/roles',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {
              body: {productRoles?: API.ProductRoles; workspaceRole?: API.WorkspaceRole};
              organizationId: string;
              workspace: string;
              userId: string;
            };
          },
        ) =>
          API.membersClient.updateWorkspaceRolesForMember(
            arg.body,
            arg.organizationId,
            arg.workspace,
            arg.userId,
            $httpConfig,
          ),
        $config,
      );
    },
  },

  queryKeys: {
    allTeamsForMember: (organizationId: string, userId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}/teams`,
    memberRolesByWorkspace: (organizationId: string, workspace: string, userId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/members/${encodeURIComponent(`${userId}`)}/roles`,
    organizationMemberRoles: (organizationId: string, userId: string, consistency?: 'standard' | 'high' | null) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}/roles?${API.encodeParams({consistency: consistency})}`,
    organizationMembers: (organizationId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/members`,
    organizationMembersByProduct: (organizationId: string, workspace: string, product: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/products/${encodeURIComponent(`${product}`)}/members`,
  },
};

export const teams = {
  queries: {
    /**
     * Get all teams for an organization
     * @param organizationId - Organization Identifier
     * @param excludeMembers (optional)
     */
    useOrganizationTeams(
      organizationId: string,
      excludeMembers?: boolean | null,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? teams.queryKeys.organizationTeams(organizationId, excludeMembers);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Team[]>(
        cacheUrl,
        () => API.teamsClient.getOrganizationTeams(organizationId, excludeMembers, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get a team
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param teamId - Team Identifier
     */
    useTeam(
      organizationId: string,
      workspace: string,
      teamId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? teams.queryKeys.team(organizationId, workspace, teamId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Team>(
        cacheUrl,
        () => API.teamsClient.getTeam(organizationId, workspace, teamId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get all teams for a user
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param userId - User Identifier
     */
    useUserTeams(
      organizationId: string,
      workspace: string,
      userId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? teams.queryKeys.userTeams(organizationId, workspace, userId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Team[]>(
        cacheUrl,
        () => API.teamsClient.getUserTeams(organizationId, workspace, userId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get all teams for a workspace
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param excludeMembers (optional)
     */
    useWorkspaceTeams(
      organizationId: string,
      workspace: string,
      excludeMembers?: boolean | null,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? teams.queryKeys.workspaceTeams(organizationId, workspace, excludeMembers);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Team[]>(
        cacheUrl,
        () => API.teamsClient.getWorkspaceTeams(organizationId, workspace, excludeMembers, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Create a new team
     * @param body
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     */
    useCreateNewTeam(
      $config?: SWRMutationConfiguration<
        API.Team,
        Error,
        string,
        {body: API.TeamCreate; organizationId: string; workspace: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<API.Team, Error, string, {body: API.TeamCreate; organizationId: string; workspace: string}>(
        '/organizations/*/workspaces/*/teams',
        (_key: string, {arg}: {arg: {body: API.TeamCreate; organizationId: string; workspace: string}}) =>
          API.teamsClient.createNewTeam(arg.body, arg.organizationId, arg.workspace, $httpConfig),
        $config,
      );
    },

    /**
     * Delete a team
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param teamId - Team Identifier
     */
    useDeleteTeam(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {organizationId: string; workspace: string; teamId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; workspace: string; teamId: string}>(
        '/organizations/*/workspaces/*/teams/*',
        (_key: string, {arg}: {arg: {organizationId: string; workspace: string; teamId: string}}) =>
          API.teamsClient.deleteTeam(arg.organizationId, arg.workspace, arg.teamId, $httpConfig),
        $config,
      );
    },

    /**
     * Update team details
     * @param body
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     * @param teamId - Team Identifier
     */
    usePatchTeam(
      $config?: SWRMutationConfiguration<
        API.Team,
        Error,
        string,
        {body: API.TeamUpdate; organizationId: string; workspace: string; teamId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.Team,
        Error,
        string,
        {body: API.TeamUpdate; organizationId: string; workspace: string; teamId: string}
      >(
        '/organizations/*/workspaces/*/teams/*',
        (
          _key: string,
          {arg}: {arg: {body: API.TeamUpdate; organizationId: string; workspace: string; teamId: string}},
        ) => API.teamsClient.patchTeam(arg.body, arg.organizationId, arg.workspace, arg.teamId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    organizationTeams: (organizationId: string, excludeMembers?: boolean | null) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/teams?${API.encodeParams({excludeMembers: excludeMembers})}`,
    team: (organizationId: string, workspace: string, teamId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams/${encodeURIComponent(`${teamId}`)}`,
    userTeams: (organizationId: string, workspace: string, userId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams/users/${encodeURIComponent(`${userId}`)}`,
    workspaceTeams: (organizationId: string, workspace: string, excludeMembers?: boolean | null) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams?${API.encodeParams({excludeMembers: excludeMembers})}`,
  },
};

export const workspaces = {
  queries: {
    /**
     * @param organizationId - organization unique identifier
     * @param workspaceId - workspace unique identifier
     */
    useInsightsDataRetention(
      organizationId: string,
      workspaceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? workspaces.queryKeys.insightsDataRetention(organizationId, workspaceId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<{days: number}>(
        cacheUrl,
        () => API.workspacesClient.getInsightsDataRetention(organizationId, workspaceId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Returns the requested workspace
     * @param organizationId - organization unique identifier
     * @param workspaceId - workspace unique identifier
     */
    useWorkspaceById(
      organizationId: string,
      workspaceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? workspaces.queryKeys.workspaceById(organizationId, workspaceId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Workspace>(
        cacheUrl,
        () => API.workspacesClient.getWorkspaceById(organizationId, workspaceId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Retrieves SMTP config for the workspace
     * @param organizationId - organization unique identifier
     * @param workspaceId - workspace unique identifier
     */
    useWorkspaceSMTPConfig(
      organizationId: string,
      workspaceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? workspaces.queryKeys.workspaceSMTPConfig(organizationId, workspaceId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.workspacesClient.getWorkspaceSMTPConfig(organizationId, workspaceId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Retrieves all worker groups in the workspace
     * @param organizationId - organization unique identifier
     * @param workspace - workspace unique name
     */
    useWorkspaceWorkergroups(
      organizationId: string,
      workspace: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? workspaces.queryKeys.workspaceWorkergroups(organizationId, workspace);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.WorkerGroups>(
        cacheUrl,
        () => API.workspacesClient.getWorkspaceWorkergroups(organizationId, workspace, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Retrieves all worker groups in the workspace by id
     * @param organizationId - organization unique identifier
     * @param workspace - workspace unique name
     * @param workergroup - workergroup unique name
     */
    useWorkspaceWorkergroupsById(
      organizationId: string,
      workspace: string,
      workergroup: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? workspaces.queryKeys.workspaceWorkergroupsById(organizationId, workspace, workergroup);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.WorkerGroup>(
        cacheUrl,
        () => API.workspacesClient.getWorkspaceWorkergroupsById(organizationId, workspace, workergroup, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Retrieves all workspaces in the organization
     * @param organizationId - organization unique identifier
     */
    useWorkspaces(organizationId: string, $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey}, $httpConfig?: KyOptions) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? workspaces.queryKeys.workspaces(organizationId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.Workspaces>(
        cacheUrl,
        () => API.workspacesClient.getWorkspaces(organizationId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Delete the workspace
     * @param organizationId - organization unique identifier
     * @param workspaceId - workspace unique identifier
     */
    useDeleteWorkspaceById(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; workspaceId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; workspaceId: string}>(
        '/organizations/*/workspaces/*',
        (_key: string, {arg}: {arg: {organizationId: string; workspaceId: string}}) =>
          API.workspacesClient.deleteWorkspaceById(arg.organizationId, arg.workspaceId, $httpConfig),
        $config,
      );
    },

    /**
     * Issues a provision command to Cribl Leader to provision Worker Group resources
     * @param body
     * @param organizationId - organization unique identifier
     * @param workspace - workspace unique name
     * @param workergroup - workergroup unique name
     */
    useProvisionWorkerGroupResources(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: API.WorkerGroupOperation; organizationId: unknown; workspace: unknown; workergroup: unknown}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: API.WorkerGroupOperation; organizationId: unknown; workspace: unknown; workergroup: unknown}
      >(
        '/organizations/*/workspaces/*/workergroups/*/operations',
        (
          _key: string,
          {
            arg,
          }: {arg: {body: API.WorkerGroupOperation; organizationId: unknown; workspace: unknown; workergroup: unknown}},
        ) =>
          API.workspacesClient.provisionWorkerGroupResources(
            arg.body,
            arg.organizationId,
            arg.workspace,
            arg.workergroup,
            $httpConfig,
          ),
        $config,
      );
    },

    /**
     * Requested a new workspace for provisioning
     * @param body
     * @param organizationId - organization unique identifier
     */
    useProvisionWorkspace(
      $config?: SWRMutationConfiguration<
        API.Workspace,
        Error,
        string,
        {
          body: {alias: string; description?: string; region: string; tags?: string[]; workspaceId: string};
          organizationId: string;
        }
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.Workspace,
        Error,
        string,
        {
          body: {alias: string; description?: string; region: string; tags?: string[]; workspaceId: string};
          organizationId: string;
        }
      >(
        '/organizations/*/workspaces',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {
              body: {alias: string; description?: string; region: string; tags?: string[]; workspaceId: string};
              organizationId: string;
            };
          },
        ) => API.workspacesClient.provisionWorkspace(arg.body, arg.organizationId, $httpConfig),
        $config,
      );
    },

    /**
     * @param body
     * @param organizationId - organization unique identifier
     * @param workspaceId - workspace unique identifier
     */
    useUpdateInsightsDataRetention(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: {days: 2 | 7 | 30 | 90 | 365}; organizationId: string; workspaceId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: {days: 2 | 7 | 30 | 90 | 365}; organizationId: string; workspaceId: string}
      >(
        '/organizations/*/workspaces/*/insightsDataRetention',
        (
          _key: string,
          {arg}: {arg: {body: {days: 2 | 7 | 30 | 90 | 365}; organizationId: string; workspaceId: string}},
        ) =>
          API.workspacesClient.updateInsightsDataRetention(arg.body, arg.organizationId, arg.workspaceId, $httpConfig),
        $config,
      );
    },

    /**
     * Update the workspace and return the updated workspace
     * @param body
     * @param organizationId - organization unique identifier
     * @param workspaceId - workspace unique identifier
     */
    useUpdateWorkspaceById(
      $config?: SWRMutationConfiguration<
        API.Workspace,
        Error,
        string,
        {body: {alias?: string; description?: string; tags?: string[]}; organizationId: string; workspaceId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.Workspace,
        Error,
        string,
        {body: {alias?: string; description?: string; tags?: string[]}; organizationId: string; workspaceId: string}
      >(
        '/organizations/*/workspaces/*',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {
              body: {alias?: string; description?: string; tags?: string[]};
              organizationId: string;
              workspaceId: string;
            };
          },
        ) => API.workspacesClient.updateWorkspaceById(arg.body, arg.organizationId, arg.workspaceId, $httpConfig),
        $config,
      );
    },

    /**
     * Update a worker group's PrivateLink configuration
     * @param body
     * @param organizationId - organization unique identifier
     * @param workspace - workspace unique name
     * @param workergroup - workergroup unique name
     */
    useUpdateWorkspaceWorkergroupsById(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: API.UpdateWorkerGroupRequest; organizationId: string; workspace: string; workergroup: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: API.UpdateWorkerGroupRequest; organizationId: string; workspace: string; workergroup: string}
      >(
        '/organizations/*/workspaces/*/workergroups/*',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {body: API.UpdateWorkerGroupRequest; organizationId: string; workspace: string; workergroup: string};
          },
        ) =>
          API.workspacesClient.updateWorkspaceWorkergroupsById(
            arg.body,
            arg.organizationId,
            arg.workspace,
            arg.workergroup,
            $httpConfig,
          ),
        $config,
      );
    },
  },

  queryKeys: {
    insightsDataRetention: (organizationId: string, workspaceId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/insightsDataRetention`,
    workspaceById: (organizationId: string, workspaceId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`,
    workspaceSMTPConfig: (organizationId: string, workspaceId: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/configs/smtp`,
    workspaceWorkergroups: (organizationId: string, workspace: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/workergroups`,
    workspaceWorkergroupsById: (organizationId: string, workspace: string, workergroup: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/workergroups/${encodeURIComponent(`${workergroup}`)}`,
    workspaces: (organizationId: string) => `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`,
  },
};

export const deployments = {
  queries: {
    /**
     * Get Auth Token for connected deployment
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     */
    useWorkspaceConnectedDeploymentAuthToken(
      organizationId: string,
      workspace: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? deployments.queryKeys.workspaceConnectedDeploymentAuthToken(organizationId, workspace);

      const {data, error, isLoading, isValidating, mutate} = useSWR<string>(
        cacheUrl,
        () => API.deploymentsClient.getWorkspaceConnectedDeploymentAuthToken(organizationId, workspace, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Get all connected deployments for a workspace
     * @param organizationId - Organization Identifier
     * @param workspace - Workspace name (ie. main)
     */
    useListWorkspaceConnectedDeployments(
      organizationId: string,
      workspace: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? deployments.queryKeys.listWorkspaceConnectedDeployments(organizationId, workspace);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.ListWorkspaceConnectedDeploymentsResponse>(
        cacheUrl,
        () => API.deploymentsClient.listWorkspaceConnectedDeployments(organizationId, workspace, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {},

  queryKeys: {
    workspaceConnectedDeploymentAuthToken: (organizationId: string, workspace: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/connected-deployments/auth-token`,
    listWorkspaceConnectedDeployments: (organizationId: string, workspace: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/connected-deployments`,
  },
};

export const main = {
  queries: {
    /**
     * Fetch a single release build
     * @param channel - release-channel name
     * @param buildId - release build identifier
     */
    useReleaseBuild(
      channel: string,
      buildId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? main.queryKeys.releaseBuild(channel, buildId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.defaultClient.getReleaseBuild(channel, buildId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Retrieve the workspace's PrivateLink configuration
     * @param organizationId - organization unique identifier
     * @param workspace - workspace unique name
     */
    useWorkspacePrivateLink(
      organizationId: string,
      workspace: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? main.queryKeys.workspacePrivateLink(organizationId, workspace);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.WorkspacePrivateLink>(
        cacheUrl,
        () => API.defaultClient.getWorkspacePrivateLink(organizationId, workspace, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * List release builds on a channel, newest first
     * @param queryParams (optional) - Grouped query parameters object (latest, summary)
     * @param channel - release-channel name
     */
    useListReleaseBuilds(
      queryParams: {latest?: 'true' | null; summary?: 'true' | null} | null | undefined,
      channel: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? main.queryKeys.listReleaseBuilds(queryParams, channel);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.defaultClient.listReleaseBuilds(queryParams, channel, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * List workspaces with an override for (component, componentChannel) — paginated
     * @param queryParams (optional) - Grouped query parameters object (cursor, pageSize)
     * @param component - component identifier
     * @param componentChannel - component channel identifier
     */
    useListWorkspacesByComponentOverride(
      queryParams: {cursor?: string | null; pageSize?: number | null} | null | undefined,
      component: string,
      componentChannel: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? main.queryKeys.listWorkspacesByComponentOverride(queryParams, component, componentChannel);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () =>
          API.defaultClient.listWorkspacesByComponentOverride(queryParams, component, componentChannel, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * List workspaces subscribed to a release channel (paginated)
     * @param queryParams (optional) - Grouped query parameters object (cursor, pageSize)
     * @param channel - release-channel name
     */
    useListWorkspacesByReleaseChannel(
      queryParams: {cursor?: string | null; pageSize?: number | null} | null | undefined,
      channel: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? main.queryKeys.listWorkspacesByReleaseChannel(queryParams, channel);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.defaultClient.listWorkspacesByReleaseChannel(queryParams, channel, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Delete a release build (idempotent)
     * @param channel - release-channel name
     * @param buildId - release build identifier
     */
    useDeleteReleaseBuild(
      $config?: SWRMutationConfiguration<unknown, Error, string, {channel: string; buildId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {channel: string; buildId: string}>(
        '/system/release-channels/*/builds/*',
        (_key: string, {arg}: {arg: {channel: string; buildId: string}}) =>
          API.defaultClient.deleteReleaseBuild(arg.channel, arg.buildId, $httpConfig),
        $config,
      );
    },

    /**
     * Update the workspace's PrivateLink configuration
     * @param body
     * @param organizationId - organization unique identifier
     * @param workspace - workspace unique name
     */
    useUpdateWorkspacePrivateLink(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: API.UpdateWorkspacePrivateLinkRequest; organizationId: string; workspace: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: API.UpdateWorkspacePrivateLinkRequest; organizationId: string; workspace: string}
      >(
        '/organizations/*/workspaces/*/privatelink',
        (
          _key: string,
          {arg}: {arg: {body: API.UpdateWorkspacePrivateLinkRequest; organizationId: string; workspace: string}},
        ) => API.defaultClient.updateWorkspacePrivateLink(arg.body, arg.organizationId, arg.workspace, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    releaseBuild: (channel: string, buildId: string) =>
      `/system/release-channels/${encodeURIComponent(`${channel}`)}/builds/${encodeURIComponent(`${buildId}`)}`,
    workspacePrivateLink: (organizationId: string, workspace: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/privatelink`,
    listReleaseBuilds: (
      queryParams: {latest?: 'true' | null; summary?: 'true' | null} | null | undefined,
      channel: string,
    ) =>
      `/system/release-channels/${encodeURIComponent(`${channel}`)}/builds?${API.encodeParams({latest: queryParams?.latest, summary: queryParams?.summary})}`,
    listWorkspacesByComponentOverride: (
      queryParams: {cursor?: string | null; pageSize?: number | null} | null | undefined,
      component: string,
      componentChannel: string,
    ) =>
      `/system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/workspaces?${API.encodeParams({cursor: queryParams?.cursor, pageSize: queryParams?.pageSize})}`,
    listWorkspacesByReleaseChannel: (
      queryParams: {cursor?: string | null; pageSize?: number | null} | null | undefined,
      channel: string,
    ) =>
      `/system/release-channels/${encodeURIComponent(`${channel}`)}/workspaces?${API.encodeParams({cursor: queryParams?.cursor, pageSize: queryParams?.pageSize})}`,
  },
};

export const searchFleets = {
  queries: {
    /**
     * List instances in a search fleet
     * Retrieves all instances for the specified search fleet
     * @param organizationId - Organization Identifier
     * @param workspaceId - Workspace Identifier
     * @param type - Deployment type
     * @param name - Search fleet identifier
     */
    useSearchFleetInstances(
      organizationId: string,
      workspaceId: string,
      type: 'search',
      name: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? searchFleets.queryKeys.searchFleetInstances(organizationId, workspaceId, type, name);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.DescribeInstancesResponse>(
        cacheUrl,
        () => API.searchFleetsClient.getSearchFleetInstances(organizationId, workspaceId, type, name, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * List search fleets
     * Retrieves fleet details for the workspace. Optionally filter by cloud provider or region using query parameters.
     * @param organizationId - Organization Identifier
     * @param workspaceId - Workspace Identifier
     * @param type - Deployment type
     * @param queryParams (optional) - Grouped query parameters object (provider, region)
     */
    useSearchFleets(
      organizationId: string,
      workspaceId: string,
      type: 'search',
      queryParams?: {provider?: 'AZURE' | 'AWS' | 'GCP' | null; region?: string | null} | null,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? searchFleets.queryKeys.searchFleets(organizationId, workspaceId, type, queryParams);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.DescribeFleetsResponse>(
        cacheUrl,
        () => API.searchFleetsClient.getSearchFleets(organizationId, workspaceId, type, queryParams, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Operate on search fleet instances
     * Perform an operation on VM instances in a search fleet. Use 'start' to power on, 'stop' to deallocate, or 'terminate' to permanently delete instances.
     * @param body
     * @param organizationId - Organization Identifier
     * @param workspaceId - Workspace Identifier
     * @param type - Deployment type
     * @param name - Search fleet identifier
     */
    useOperateSearchFleetInstances(
      $config?: SWRMutationConfiguration<
        API.OperationInstancesResponse,
        Error,
        string,
        {body: API.OperateInstancesRequest; organizationId: string; workspaceId: string; type: 'search'; name: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.OperationInstancesResponse,
        Error,
        string,
        {body: API.OperateInstancesRequest; organizationId: string; workspaceId: string; type: 'search'; name: string}
      >(
        '/organizations/*/workspaces/*/deployments/*/*/operations',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {
              body: API.OperateInstancesRequest;
              organizationId: string;
              workspaceId: string;
              type: 'search';
              name: string;
            };
          },
        ) =>
          API.searchFleetsClient.operateSearchFleetInstances(
            arg.body,
            arg.organizationId,
            arg.workspaceId,
            arg.type,
            arg.name,
            $httpConfig,
          ),
        $config,
      );
    },

    /**
     * Update search fleet capacity
     * Updates target capacity for a search fleet. Only capacity increases are allowed; decreases are rejected to prevent accidental data loss.
     * @param body
     * @param organizationId - Organization Identifier
     * @param workspaceId - Workspace Identifier
     * @param type - Deployment type
     * @param name - Search fleet identifier
     */
    useUpdateSearchFleet(
      $config?: SWRMutationConfiguration<
        API.ModifyFleetResponse,
        Error,
        string,
        {
          body: API.UpdateFleetCapacityRequest;
          organizationId: string;
          workspaceId: string;
          type: 'search';
          name: string;
        }
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.ModifyFleetResponse,
        Error,
        string,
        {
          body: API.UpdateFleetCapacityRequest;
          organizationId: string;
          workspaceId: string;
          type: 'search';
          name: string;
        }
      >(
        '/organizations/*/workspaces/*/deployments/*/*',
        (
          _key: string,
          {
            arg,
          }: {
            arg: {
              body: API.UpdateFleetCapacityRequest;
              organizationId: string;
              workspaceId: string;
              type: 'search';
              name: string;
            };
          },
        ) =>
          API.searchFleetsClient.updateSearchFleet(
            arg.body,
            arg.organizationId,
            arg.workspaceId,
            arg.type,
            arg.name,
            $httpConfig,
          ),
        $config,
      );
    },
  },

  queryKeys: {
    searchFleetInstances: (organizationId: string, workspaceId: string, type: 'search', name: string) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/deployments/${encodeURIComponent(`${type}`)}/${encodeURIComponent(`${name}`)}/instances`,
    searchFleets: (
      organizationId: string,
      workspaceId: string,
      type: 'search',
      queryParams?: {provider?: 'AZURE' | 'AWS' | 'GCP' | null; region?: string | null} | null,
    ) =>
      `/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/deployments/${encodeURIComponent(`${type}`)}/fleets?${API.encodeParams({provider: queryParams?.provider, region: queryParams?.region})}`,
  },
};

export const system = {
  queries: {
    /**
     * Retrieve available login connections by organization for the provided email
     * @param email
     * @param authorization (API name: Authorization) - Bearer verification token for this email
     */
    useLoginOptions(
      email: string,
      authorization: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? system.queryKeys.loginOptions(email, authorization);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.LoginOptionsResponse>(
        cacheUrl,
        () => API.systemClient.getLoginOptions(email, authorization, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * List system roles for a user
     * @param userId - Required User Identifier
     */
    useListSystemRolesByUser(
      userId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? system.queryKeys.listSystemRolesByUser(userId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.ListSystemRolesByUserResponse>(
        cacheUrl,
        () => API.systemClient.listSystemRolesByUser(userId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Add system role to a user
     * @param body
     * @param userId - Required User Identifier
     */
    useAddSystemRoleToUser(
      $config?: SWRMutationConfiguration<
        API.AddSystemRoleToUserResponse,
        Error,
        string,
        {body: API.AddSystemRoleToUserRequest; userId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.AddSystemRoleToUserResponse,
        Error,
        string,
        {body: API.AddSystemRoleToUserRequest; userId: string}
      >(
        '/system/users/*/roles',
        (_key: string, {arg}: {arg: {body: API.AddSystemRoleToUserRequest; userId: string}}) =>
          API.systemClient.addSystemRoleToUser(arg.body, arg.userId, $httpConfig),
        $config,
      );
    },

    /**
     * Get system roles/permissions access report for user
     * @param body
     */
    useCheckSystemAccess(
      $config?: SWRMutationConfiguration<
        API.SystemAccessCheckResponse,
        Error,
        string,
        {body: API.SystemAccessCheckRequest}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<API.SystemAccessCheckResponse, Error, string, {body: API.SystemAccessCheckRequest}>(
        '/system/access',
        (_key: string, {arg}: {arg: {body: API.SystemAccessCheckRequest}}) =>
          API.systemClient.checkSystemAccess(arg.body, $httpConfig),
        $config,
      );
    },

    /**
     * Resolve next login action and optionally trigger OTC challenge
     * @param body
     */
    usePreLogin(
      $config?: SWRMutationConfiguration<API.PreLoginResponse, Error, string, {body: API.PreLoginRequest}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<API.PreLoginResponse, Error, string, {body: API.PreLoginRequest}>(
        '/system/pre-login',
        (_key: string, {arg}: {arg: {body: API.PreLoginRequest}}) => API.systemClient.preLogin(arg.body, $httpConfig),
        $config,
      );
    },

    /**
     * Exchange OTC verification code for login token
     * @param body
     */
    usePreLoginToken(
      $config?: SWRMutationConfiguration<API.PreLoginTokenResponse, Error, string, {body: API.PreLoginTokenRequest}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<API.PreLoginTokenResponse, Error, string, {body: API.PreLoginTokenRequest}>(
        '/system/pre-login-token',
        (_key: string, {arg}: {arg: {body: API.PreLoginTokenRequest}}) =>
          API.systemClient.preLoginToken(arg.body, $httpConfig),
        $config,
      );
    },

    /**
     * Remove system role from a user
     * @param body
     * @param userId - Required User Identifier
     */
    useRemoveSystemRoleFromUser(
      $config?: SWRMutationConfiguration<
        API.RemoveSystemRoleFromUserResponse,
        Error,
        string,
        {body: API.RemoveSystemRoleFromUserRequest; userId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.RemoveSystemRoleFromUserResponse,
        Error,
        string,
        {body: API.RemoveSystemRoleFromUserRequest; userId: string}
      >(
        '/system/users/*/roles',
        (_key: string, {arg}: {arg: {body: API.RemoveSystemRoleFromUserRequest; userId: string}}) =>
          API.systemClient.removeSystemRoleFromUser(arg.body, arg.userId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    loginOptions: (email: string, authorization: string) => `/system/login-options?${API.encodeParams({email: email})}`,
    listSystemRolesByUser: (userId: string) => `/system/users/${encodeURIComponent(`${userId}`)}/roles`,
  },
};

export const components = {
  queries: {
    /**
     * Fetch a component build by id
     * @param component - component identifier
     * @param componentChannel - component channel name
     * @param buildId - build identifier
     */
    useComponentBuild(
      component: string,
      componentChannel: string,
      buildId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? components.queryKeys.componentBuild(component, componentChannel, buildId);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.componentsClient.getComponentBuild(component, componentChannel, buildId, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * List component builds on a channel
     * @param latest (optional) - when 'true', collapses items to the channel marker's latest build
     * @param component - component identifier (e.g. stream)
     * @param componentChannel - component channel name
     */
    useListComponentBuilds(
      latest: string | null | undefined,
      component: string,
      componentChannel: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? components.queryKeys.listComponentBuilds(latest, component, componentChannel);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.componentsClient.listComponentBuilds(latest, component, componentChannel, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * List all channels carrying a build for a component
     * @param component - component identifier
     */
    useListComponentChannels(
      component: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? components.queryKeys.listComponentChannels(component);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.componentsClient.listComponentChannels(component, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Register a new component build on a channel
     * @param body
     * @param component - component identifier (e.g. stream)
     * @param componentChannel - component channel name
     */
    useCreateComponentBuild(
      $config?: SWRMutationConfiguration<
        Record<string, unknown>,
        Error,
        string,
        {body: Record<string, unknown>; component: string; componentChannel: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        Record<string, unknown>,
        Error,
        string,
        {body: Record<string, unknown>; component: string; componentChannel: string}
      >(
        '/system/components/*/channels/*/builds',
        (_key: string, {arg}: {arg: {body: Record<string, unknown>; component: string; componentChannel: string}}) =>
          API.componentsClient.createComponentBuild(arg.body, arg.component, arg.componentChannel, $httpConfig),
        $config,
      );
    },

    /**
     * Delete a component build (idempotent)
     * @param component - component identifier
     * @param componentChannel - component channel name
     * @param buildId - build identifier
     */
    useDeleteComponentBuild(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {component: string; componentChannel: string; buildId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {component: string; componentChannel: string; buildId: string}>(
        '/system/components/*/channels/*/builds/*',
        (_key: string, {arg}: {arg: {component: string; componentChannel: string; buildId: string}}) =>
          API.componentsClient.deleteComponentBuild(arg.component, arg.componentChannel, arg.buildId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    componentBuild: (component: string, componentChannel: string, buildId: string) =>
      `/system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/builds/${encodeURIComponent(`${buildId}`)}`,
    listComponentBuilds: (latest: string | null | undefined, component: string, componentChannel: string) =>
      `/system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/builds?${API.encodeParams({latest: latest})}`,
    listComponentChannels: (component: string) => `/system/components/${encodeURIComponent(`${component}`)}/channels`,
  },
};

export const productBuilds = {
  queries: {
    /**
     * Resolves a product build subscription
     * @param queryParams - Grouped query parameters object (channel, version, build)
     */
    useLatestProductBuild(
      queryParams: {channel: string; version: string; build?: string | null},
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? productBuilds.queryKeys.latestProductBuild(queryParams);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.ProductBuild>(
        cacheUrl,
        () => API.productBuildsClient.getLatestProductBuild(queryParams, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Lists all builds on a release channel
     * @param channel - release channel
     * @param version - partial or complete semantic version
     * @param build (optional) - build id to inspect
     */
    useListAllChannelProductBuilds(
      channel: string,
      version: string,
      build?: string | null,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? productBuilds.queryKeys.listAllChannelProductBuilds(channel, version, build);

      const {data, error, isLoading, isValidating, mutate} = useSWR<API.ProductBuild[]>(
        cacheUrl,
        () => API.productBuildsClient.listAllChannelProductBuilds(channel, version, build, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /**
     * Lists all workspaces on a release channel
     * @param channel - release channel
     */
    useListProductBuildSubscriptions(
      channel: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? productBuilds.queryKeys.listProductBuildSubscriptions(channel);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.productBuildsClient.listProductBuildSubscriptions(channel, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Creates a product build
     * @param body
     */
    useCreateProductBuild(
      $config?: SWRMutationConfiguration<Record<string, unknown>, Error, string, {body: API.ProductBuild}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<Record<string, unknown>, Error, string, {body: API.ProductBuild}>(
        '/system/productbuilds',
        (_key: string, {arg}: {arg: {body: API.ProductBuild}}) =>
          API.productBuildsClient.createProductBuild(arg.body, $httpConfig),
        $config,
      );
    },

    /**
     * Deletes a product build
     * @param queryParams - Grouped query parameters object (channel, version, build)
     */
    useDeleteProductBuild(
      $config?: SWRMutationConfiguration<
        Record<string, unknown>,
        Error,
        string,
        {queryParams: {channel: string; version: string; build: string}}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        Record<string, unknown>,
        Error,
        string,
        {queryParams: {channel: string; version: string; build: string}}
      >(
        '/system/productbuilds',
        (_key: string, {arg}: {arg: {queryParams: {channel: string; version: string; build: string}}}) =>
          API.productBuildsClient.deleteProductBuild(arg.queryParams, $httpConfig),
        $config,
      );
    },

    /**
     * Patches a product build
     * @param body
     */
    useUpdateProductBuild(
      $config?: SWRMutationConfiguration<Record<string, unknown>, Error, string, {body: API.ProductBuild}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<Record<string, unknown>, Error, string, {body: API.ProductBuild}>(
        '/system/productbuilds',
        (_key: string, {arg}: {arg: {body: API.ProductBuild}}) =>
          API.productBuildsClient.updateProductBuild(arg.body, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    latestProductBuild: (queryParams: {channel: string; version: string; build?: string | null}) =>
      `/system/productbuilds?${API.encodeParams({channel: queryParams?.channel, version: queryParams?.version, build: queryParams?.build})}`,
    listAllChannelProductBuilds: (channel: string, version: string, build?: string | null) =>
      `/system/productbuilds/${encodeURIComponent(`${channel}`)}/${encodeURIComponent(`${version}`)}?${API.encodeParams({build: build})}`,
    listProductBuildSubscriptions: (channel: string) =>
      `/system/productbuilds/${encodeURIComponent(`${channel}`)}/workspaces`,
  },
};

export const releaseChannels = {
  queries: {
    /**
     * Fetch a single release-channel config
     * @param channel - release-channel name (e.g. ga, rd, stage-default)
     */
    useReleaseChannelConfig(
      channel: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: SWRKey},
      $httpConfig?: KyOptions,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? releaseChannels.queryKeys.releaseChannelConfig(channel);

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.releaseChannelsClient.getReleaseChannelConfig(channel, $httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },

    /** List every release-channel config */
    useListReleaseChannelConfigs($config?: Omit<SwrConfig, 'key'> & {key?: SWRKey}, $httpConfig?: KyOptions) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? releaseChannels.queryKeys.listReleaseChannelConfigs();

      const {data, error, isLoading, isValidating, mutate} = useSWR<Record<string, unknown>>(
        cacheUrl,
        () => API.releaseChannelsClient.listReleaseChannelConfigs($httpConfig),
        config,
      );

      return {data, isLoading, isValidating, error, mutate};
    },
  },

  mutations: {
    /**
     * Create a release-channel config
     * @param body
     */
    useCreateReleaseChannelConfig(
      $config?: SWRMutationConfiguration<Record<string, unknown>, Error, string, {body: Record<string, unknown>}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<Record<string, unknown>, Error, string, {body: Record<string, unknown>}>(
        '/system/release-channels',
        (_key: string, {arg}: {arg: {body: Record<string, unknown>}}) =>
          API.releaseChannelsClient.createReleaseChannelConfig(arg.body, $httpConfig),
        $config,
      );
    },

    /**
     * Delete a release-channel config (idempotent)
     * @param channel - release-channel name (e.g. ga, rd, stage-default)
     */
    useDeleteReleaseChannelConfig(
      $config?: SWRMutationConfiguration<unknown, Error, string, {channel: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {channel: string}>(
        '/system/release-channels/*',
        (_key: string, {arg}: {arg: {channel: string}}) =>
          API.releaseChannelsClient.deleteReleaseChannelConfig(arg.channel, $httpConfig),
        $config,
      );
    },

    /**
     * Partial update of a release-channel config
     * @param body
     * @param channel - release-channel name (e.g. ga, rd, stage-default)
     */
    usePatchReleaseChannelConfig(
      $config?: SWRMutationConfiguration<
        Record<string, unknown>,
        Error,
        string,
        {body: Record<string, unknown>; channel: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<Record<string, unknown>, Error, string, {body: Record<string, unknown>; channel: string}>(
        '/system/release-channels/*',
        (_key: string, {arg}: {arg: {body: Record<string, unknown>; channel: string}}) =>
          API.releaseChannelsClient.patchReleaseChannelConfig(arg.body, arg.channel, $httpConfig),
        $config,
      );
    },

    /**
     * Remove a component subscription from a channel
     * @param channel - release-channel name
     * @param component - component name being subscribed
     */
    useRemoveReleaseChannelSubscription(
      $config?: SWRMutationConfiguration<unknown, Error, string, {channel: string; component: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {channel: string; component: string}>(
        '/system/release-channels/*/subscriptions/*',
        (_key: string, {arg}: {arg: {channel: string; component: string}}) =>
          API.releaseChannelsClient.removeReleaseChannelSubscription(arg.channel, arg.component, $httpConfig),
        $config,
      );
    },

    /**
     * Set or change a component subscription on a channel
     * @param body
     * @param channel - release-channel name
     * @param component - component name being subscribed
     */
    useSetReleaseChannelSubscription(
      $config?: SWRMutationConfiguration<
        Record<string, unknown>,
        Error,
        string,
        {body: Record<string, unknown>; channel: string; component: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        Record<string, unknown>,
        Error,
        string,
        {body: Record<string, unknown>; channel: string; component: string}
      >(
        '/system/release-channels/*/subscriptions/*',
        (_key: string, {arg}: {arg: {body: Record<string, unknown>; channel: string; component: string}}) =>
          API.releaseChannelsClient.setReleaseChannelSubscription(arg.body, arg.channel, arg.component, $httpConfig),
        $config,
      );
    },

    /**
     * Fire the release-build evaluator for a single channel
     * @param channel - release-channel name
     */
    useTriggerReleaseChannel(
      $config?: SWRMutationConfiguration<Record<string, unknown>, Error, string, {channel: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<Record<string, unknown>, Error, string, {channel: string}>(
        '/system/release-channels/*/trigger',
        (_key: string, {arg}: {arg: {channel: string}}) =>
          API.releaseChannelsClient.triggerReleaseChannel(arg.channel, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {
    releaseChannelConfig: (channel: string) => `/system/release-channels/${encodeURIComponent(`${channel}`)}`,
    listReleaseChannelConfigs: () => `/system/release-channels`,
  },
};

export const users = {
  queries: {},

  mutations: {
    /**
     * Sends a verification email for user's Auth0 account
     * @param userId - User Identifier
     */
    useCreateUserVerificationEmail(
      $config?: SWRMutationConfiguration<unknown, Error, string, {userId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {userId: string}>(
        '/users/*/verification-email',
        (_key: string, {arg}: {arg: {userId: string}}) =>
          API.usersClient.createUserVerificationEmail(arg.userId, $httpConfig),
        $config,
      );
    },

    /**
     * Update current user's profile metadata in Auth0
     * @param body
     * @param userId - User Identifier
     */
    useUpdateProfile(
      $config?: SWRMutationConfiguration<unknown, Error, string, {body: API.UpdateProfileRequest; userId: string}>,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<unknown, Error, string, {body: API.UpdateProfileRequest; userId: string}>(
        '/users/*/profile',
        (_key: string, {arg}: {arg: {body: API.UpdateProfileRequest; userId: string}}) =>
          API.usersClient.updateProfile(arg.body, arg.userId, $httpConfig),
        $config,
      );
    },

    /**
     * Update current user's onboarding metadata in Auth0
     * @param body
     * @param userId - User Identifier
     */
    useUpdateProfileOnboarding(
      $config?: SWRMutationConfiguration<
        API.UpdateProfileOnboardingResponse,
        Error,
        string,
        {body: API.UpdateProfileOnboardingRequest; userId: string}
      >,
      $httpConfig?: KyOptions,
    ) {
      return useSWRMutation<
        API.UpdateProfileOnboardingResponse,
        Error,
        string,
        {body: API.UpdateProfileOnboardingRequest; userId: string}
      >(
        '/users/*/profile/onboarding',
        (_key: string, {arg}: {arg: {body: API.UpdateProfileOnboardingRequest; userId: string}}) =>
          API.usersClient.updateProfileOnboarding(arg.body, arg.userId, $httpConfig),
        $config,
      );
    },
  },

  queryKeys: {},
};
